import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IUpdateAIWorkspacePayload } from "../types";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.GET],
  skipInvalidation: false,
};

export function useUpdateAiWorkspace(config?: {
  onSuccess?: () => void;
  showSuccessToast?: boolean;
  showErrorToast?: boolean;
}) {
  const showSuccess = config?.showSuccessToast ?? false;
  const showError = config?.showErrorToast ?? true;

  const updateAiWorkspace = useCallback(
    (payload: IUpdateAIWorkspacePayload) =>
      AiWorkspaceService.updateAIWorkspace(payload)
        .then((res) => {
          if (showSuccess) {
            ToastService.success("AI Workspace updated successfully");
          }
          return res;
        })
        .catch(async (err) => {
          let errorMessage = "Failed to update AI Workspace";
          if (err?.response) {
            try {
              const responseBody = await err.response.json();
              if (responseBody?.msg) errorMessage = responseBody.msg;
            } catch (e) {}
          }
          if (showError) {
            ToastService.error(errorMessage);
          }
          throw err;
        }),
    [showSuccess, showError]
  );

  const {
    mutate: update,
    isLoading: isUpdating,
    isSuccess: isUpdated,
  } = useMutation<IUpdateAIWorkspacePayload>({
    mutationFn: updateAiWorkspace,
    options: QUERY_OPTIONS,
    onSuccess: config?.onSuccess,
  });

  return {
    update,
    isUpdating,
    isUpdated,
  };
}
